// extracted by mini-css-extract-plugin
export var icon = "_wp-0";